import React, { useEffect, useState } from 'react';
import { Spin, Input, Form, Row, Col, Card, Modal, Button, message } from 'antd';
import Cookies from 'js-cookie';
import PageTitle from "components/PageTitle";
import {
  getProfile,
  updateProfile,
} from "requests/user";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const token = Cookies.get('token');

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setIsTableLoading(true);
      const res = await getProfile();
      console.log("Fetched profile:", res?.data);
      if (res?.status === "1") {
        setProfile(res.data);   // ✅ your API has { status, message, data }
        form.setFieldsValue(res.data);
      } else {
        message.error(res?.message || "Failed to fetch profile");
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      message.error("Something went wrong while fetching profile");
    } finally {
      setIsTableLoading(false);
    }
  };

  const handleUpdate = async (values) => {
    try {
      const res = await updateProfile(values);
      if (res?.status === "1") {
        message.success("Profile updated successfully!");
        setIsModalVisible(false);
        fetchProfile();
      } else {
        message.error(res?.message || "Update failed");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      message.error("Something went wrong while updating profile");
    }
  };

  const titles = [{ title: "Profile" }];

  return (
    <div>
      <div className="overviewBorder mb-24">
        <Row justify="space-between" align="middle">
          <Col xs={24} md={12} lg={12}>
            <Card className="small_card">
              <PageTitle titles={titles} />
            </Card>
          </Col>
        </Row>
      </div>

      <div style={{ margin: "auto" }}>
        {isTableLoading ? (
          <Spin />
        ) : profile ? (
          <>
<Row gutter={16} justify={'center'}>
  <Col xs={24} md={12} >
  <Form layout='vertical'>
    <Form.Item label="Name">
                <Input value={profile.fullname} disabled />
              </Form.Item>
               <Form.Item label="Mobile">
                <Input value={profile.mobile} disabled />
              </Form.Item>
               <Form.Item label="Pan Gst">
                <Input value={profile.pan_gst} disabled />
              </Form.Item>
  </Form>
  </Col>
  <Col xs={24} md={12}>
   <Form layout='vertical'>
     <Form.Item label="Email">
                <Input value={profile.email} disabled />
              </Form.Item>
               <Form.Item label="Address">
                <Input value={profile.address} disabled />
              </Form.Item>
     <Form.Item label="Role">
                <Input value={profile.role} disabled />
              </Form.Item>
  </Form>
  </Col>

</Row>




            {/* <Form layout="vertical">
              <Form.Item label="Name">
                <Input value={profile.fullname} disabled />
              </Form.Item>
              <Form.Item label="Email">
                <Input value={profile.email} disabled />
              </Form.Item>
              <Form.Item label="Mobile">
                <Input value={profile.mobile} disabled />
              </Form.Item>
              <Form.Item label="Address">
                <Input value={profile.address} disabled />
              </Form.Item>
              <Form.Item label="Pan Gst">
                <Input value={profile.pan_gst} disabled />
              </Form.Item>
              <Form.Item label="Role">
                <Input value={profile.role} disabled />
              </Form.Item>
              <Form.Item>
                <Button type="primary" onClick={() => setIsModalVisible(true)}>
                  Edit Profile
                </Button> 
              </Form.Item>
            </Form> */}

            <Modal
              title="Edit Profile"
              open={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              onOk={() => {
                form
                  .validateFields()
                  .then((values) => handleUpdate(values))
                  .catch((info) => console.log("Validate Failed:", info));
              }}
              okText="Update"
              cancelText="Cancel"
            >
              <Form layout="vertical" form={form}>
                <Form.Item
                  label="Name"
                  name="fullname"
                  rules={[{ required: true, message: "Please enter name" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[{ required: true, message: "Please enter email" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Mobile"
                  name="mobile"
                  rules={[{ required: true, message: "Please enter mobile" }]}
                >
                  <Input />
                </Form.Item>
                
                <Form.Item
                  label="Old Password"
                  name="old_password"
                  rules={[{ required: true, message: "Please enter old password" }]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  label="New Password"
                  name="new_password"
                  rules={[{ required: true, message: "Please enter new password" }]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  label="Confirm Password"
                  name="confirm_password"
                  dependencies={['new_password']}
                  rules={[
                    { required: true, message: "Please enter confirm password" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('new_password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Passwords do not match!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </Form>
            </Modal>
          </>
        ) : (
          <p>No profile data available</p>
        )}
      </div>
    </div>
  );
};

export default Profile;
